module.exports = __webpack_public_path__ + "img/C08TechMahoutTraining_ua.f5d5af3d.webp";